import {Injectable, Injector} from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import {environment} from '@modweb5/environments/frontends/environment';
import { EColumnFilterModes, ETablePositions } from '@modweb5/sharedEnums/tableModeTypes.enum';
import { Translation } from '@modweb5/interfaces/translation.interface';
import { TColumn, TLocalStore, TColumnsMap, TColumnsArray, TColumnSelectedPropertyArray, TLocalStoreSection } 
		from '@modweb5/interfaces/table.interface'
import { TConfigForCalendar } from '@modweb5/interfaces/todo.interface';
import { ETableModes, TTableModes } from '@modweb5/sharedEnums/tableModeTypes.enum';


@Injectable({
	providedIn: 'root'
})
export class CommonService {


	constructor(
	) {}

	// ------------------------------------------------------------------------------------------
	setTranslatedTexts = (aTransTextLang: {[key: string]: Translation}, aLang: string): {[key: string]: string} => {
	// ------------------------------------------------------------------------------------------

		const transTextLang = {};
		for (let key in aTransTextLang) {
			transTextLang[key] = aTransTextLang[key][aLang];
		}
		return transTextLang;
	}

	// ------------------------------------------------------------------------------------------
	getLocalStoreItemExists(aLocalStoreName: string, aSection: string) {

		let pResult = false;
		if (localStorage.getItem(aLocalStoreName) !== null) {
			let allValues: TLocalStore =  JSON.parse(String(localStorage.getItem(aLocalStoreName)));
			if (typeof allValues[aSection] !== typeof undefined) {
				pResult = true;
			}
		}
		return pResult;
	}

	//-----------------------------------------------------------------------------------------------
	showDetailForModule(tableMode: TTableModes): boolean {
		return (tableMode === ETableModes.DETAIL || tableMode === ETableModes.INSERT || tableMode === ETableModes.UPDATE);
	}

	//-----------------------------------------------------------------------------------------------
	getLocalStoreTableWidth(aLocalStoreName: string): number {

		let allValues =  JSON.parse(String(localStorage.getItem(aLocalStoreName)));
		return Number(allValues['tableWidth']);
	}

	//-----------------------------------------------------------------------------------------------
	setLocalStoreTableWidth(aLocalStoreName: string, aValue: number): void {
		let allValues: TLocalStoreSection = {};
		if (localStorage.getItem(aLocalStoreName) !== null) {
			allValues = JSON.parse(String(localStorage.getItem(aLocalStoreName)));
		}
		allValues['tableWidth'] = aValue;
		localStorage.setItem(aLocalStoreName, JSON.stringify(allValues));
	}

	// ------------------------------------------------------------------------------------------
	getCookie = (cookieName): string | null => {
	// ------------------------------------------------------------------------------------------

		const splitCookies = document.cookie.split('; ');
		const arrayCookies = new Array();
		let i;
		for (i in splitCookies) {
			if (splitCookies.hasOwnProperty(i)) {
				arrayCookies[(splitCookies[i].split('=')[0])] = splitCookies[i].split('=')[1];
			}
		}
		if (typeof arrayCookies[cookieName] === typeof undefined) {
			return null;
		} else {
			return arrayCookies[cookieName];
		}
	}
	
	// ------------------------------------------------------------------------------------------
	setCookie = (cookieName, cookieValue, cookieDays): void => {
	// Když cookieDays = -1, ruší se cookies
	// Když -2 a méně, je to jen ve vteřinách
	// ------------------------------------------------------------------------------------------
		var today = new Date();
		var expire = new Date();

		if (cookieDays == null || cookieDays === 0) {
			cookieDays = 1;
		}
		if (cookieDays < -1) { // Pokud menší než -1, je platnost ve vteřinách
			expire.setTime(today.getTime() + 1000 * (-cookieDays));
		} else {
			expire.setTime(today.getTime() + 3600000 * 24 * cookieDays);
		}
		var pDomain = '/';
		document.cookie = cookieName+'='+cookieValue+';expires='+expire+';path='+pDomain+';samesite=strict';
	}

	//-----------------------------------------------------------------------------------------------
	sorting(objPrev: any, objNext: any, sortDirection: number, fieldType: string, sortedValue: string): number {
	//-----------------------------------------------------------------------------------------------

		let result;
		if ((fieldType === 'string') || (fieldType === 'date') || (fieldType === 'datetime')) {
			if ((typeof objPrev[sortedValue] === typeof undefined) || (objPrev[sortedValue] === null)) {
				objPrev[sortedValue] = '';
			}
			if ((typeof objNext[sortedValue] === typeof undefined) || (objNext[sortedValue] === null)) {
				objNext[sortedValue] = '';
			}
			result = (objPrev[sortedValue] as string).localeCompare(objNext[sortedValue] as string, 'cs', { sensitivity: 'base' });
		} else {
			result = (objPrev[sortedValue] < objNext[sortedValue])
				? -1
				: (objPrev[sortedValue] > objNext[sortedValue])
					? 1
					: 0;
		}
		if ((result === 0) && (typeof objPrev.id !== typeof undefined) && (typeof objNext.id !== typeof undefined)) {
			// Pokud jsou hodnoty ve sloupci dle kterého se třídí stejné, jsou v případě vzestupného třídění záznamy s menším id (přidané dříve)
			// před záznamy s vyšším id. V případě sestupného třídění jsou záznamy s větším id (přidané později) před záznamy s nižším id.
			// Je to například proto, aby práce, které se prováděly ve stejný den, byly setříděny dle pořadí, jak se zadávaly do databáze.
			if (sortDirection > 0) {
				// vzestupně
					if (objPrev.id < objNext.id) {
					result = -1;
				} else if (objPrev.id > objNext.id) {
					result = 1;
				}
			}	else {
					if (objPrev.id < objNext.id) {
					result = 1;
				} else if (objPrev.id > objNext.id) {
					result = -1;
				}
			}
		}
		else {
			result = result * sortDirection;
		}
		return result;
	}


	// ------------------------------------------------------------------------------------------
	getConfigForCalendar = (aLang): TConfigForCalendar => {

		let config: TConfigForCalendar = {
			dayNames: [ "Neděle","Pondělí","Úterý","Středa","Čtvrtek","Pátek","Sobota" ],
			dayNamesShort: [ "Ne","Po","Út","St","Čt","Pá","So" ],
			dayNamesMin: [ "Ne","Po","Út","St","Čt","Pá","So" ],
			monthNames: [ "Leden","Únor","Březen","Duben","Květen","Červen","Červenec","Srpen","Září","Říjen","Listopad","Prosinec" ],
			monthNamesShort: [ "LED","ÚNO","BŘE","DUB","KVĚ","ČEN","ČEC","SRP","ZÁŘ","ŘÍJ","LIS","PRO" ],
			today: 'Dnes',
			clear: 'Vymazat'
		}
		switch (aLang) {
			case 'en':
				config = {
					dayNames: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
					dayNamesShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
					dayNamesMin: [ "Su","Mo","Tu","We","Th","Fr","Sa" ],
					monthNames: [ "January","February","March","April","May","June", "July","August","September","October","November","December" ],
					monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
					today: 'Today',
					clear: 'Clear'
				}
				break;
			default:
				break;
		}
		return config;
	}

	// ------------------------------------------------------------------------------------------
	dateToString = (aDate, aFormatString, aStartZero): string => {

		let pResultFcn = '';
		var mDate		= {
			'S': aDate.getSeconds(),
			'M': aDate.getMinutes(),
			'H': aDate.getHours(),
			'd': aDate.getDate(),
			'm': aDate.getMonth() + 1,
			'y': aDate.getFullYear(),
		}

		pResultFcn = aFormatString.replace(/([SMHdmy])/g, function(key) {
			if (aStartZero) {
			 return (mDate[key] < 10 ? '0' : '') + mDate[key];
			} else {
				return mDate[key];
			}
		});
		return pResultFcn;
	}

	// ------------------------------------------------------------------------------------------
	stringToDate = (aDate: string): any => {
		return new Date(aDate);
	}

	// ------------------------------------------------------------------------------------------
	transSecondsTo_d_hh_mm_ss = (aSeconds: number): string => {

		let resultFcn: string;
		if (aSeconds > 0) {
			const days   = Math.floor(aSeconds / (3600 * 24));
			let restSeconds = aSeconds - (days * 3600 * 24);
			let hours   = Math.floor(restSeconds / 3600);
			restSeconds = restSeconds - (hours * 3600);
			let minutes   = Math.floor(restSeconds / 60);
			restSeconds = restSeconds - (minutes * 60);

			let daysStr = String(days);
			let hoursStr = String(hours);
			let minutesStr = String(minutes);
			let secondsStr = String(restSeconds);

			if (hours   < 10) { hoursStr = '0' + hoursStr; }
			if (minutes   < 10) { minutesStr = '0' + minutesStr; }
			if (restSeconds   < 10) { secondsStr = '0' + secondsStr; }

			if (days > 0) {
				if (days == 1) {
					resultFcn = daysStr + ' den ' + hoursStr + ':' + minutesStr + ':' + secondsStr;
				}
				else if (days < 5) {
					resultFcn = daysStr + ' dny ' + hoursStr + ':' + minutesStr + ':' + secondsStr;
				}
				else {
					resultFcn = daysStr + ' dnů ' + hoursStr + ':' + minutesStr + ':' + secondsStr;
				}
			} else {
				resultFcn = hoursStr + ':' + minutesStr + ':' + secondsStr;
			}
		} else {
			resultFcn = '00:00:00';
		}

		return resultFcn;
	}


	// ------------------------------------------------------------------------------------------
	transformDateFromClientToServer = (aDate: any, fieldType: string): any => {
		let resultFcn = { date: null, date_sort: null };
		if (((typeof aDate === 'object') || (typeof aDate === 'string'))
			&& (aDate !== null) && (aDate !== '')) {
			let mydate;
			if ((typeof aDate === 'string') && fieldType != 'time') {
				let formatDate;
				if (fieldType === 'date') {
					if (aDate.indexOf(' ') > -1) {
						// Pokud se má transformovat date, ale byl předán parametr datatime např. "03.11.2022 00:00:00", ořežeme čas.
						const dt = aDate.split(" ");
						aDate = dt[0];
					}
					formatDate = aDate.split(".").reverse().join("-");
				} else if (fieldType === 'datetime') {
					const dt = aDate.split(" ");
					formatDate = dt[0].split(".").reverse().join("-");
					formatDate += ' ' + dt[1];
				}
				mydate = this.stringToDate(formatDate);
			} else {
				mydate = aDate;
			}
			if (fieldType === 'date') {
				resultFcn.date = this.dateToString(mydate, 'd.m.y', true);
				resultFcn.date_sort = this.dateToString(mydate, 'y-m-d', true);
			} else if (fieldType === 'datetime') {
				resultFcn.date = this.dateToString(mydate, 'd.m.y H:M:S', true);
				resultFcn.date_sort = this.dateToString(mydate, 'y-m-d H:M:S', true);
			} else if (fieldType === 'time') {
				resultFcn.date = ((typeof aDate !== 'string') ? this.dateToString(mydate, 'H:M', true) : mydate);
				resultFcn.date_sort = ((typeof aDate !== 'string') ? this.dateToString(mydate, 'H:M', true) : mydate);
			}
		}

		return resultFcn;
	}
	
/*
	// ------------------------------------------------------------------------------------------
	transformDateTimeFromClientToServer = (aDate: any): any => {
		let resultFcn = { date: null, date_sort: null };

		if (((typeof aDate === 'object') || (typeof aDate === 'string'))
			&& (aDate !== null) && (aDate !== '')) {
			let mydate;
			if (typeof aDate === 'string') {
				const formatDate = aDate.split(".").reverse().join("-");
				mydate = this.stringToDate(formatDate);
			} else {
				mydate = aDate;
			} 

			resultFcn.date = this.dateToString(mydate, 'd.m.y', true);
			resultFcn.date_sort = this.dateToString(mydate, 'y-m-d', true);
		}
		return resultFcn;
	}
*/

	// ------------------------------------------------------------------------------------------
	getToday = (): string => {

		const today = new Date();
		return this.dateToString(today, 'd.m.y', true);
	}


	// ------------------------------------------------------------------------------------------
	getTodayWithCurrentTime = (incrementSeconds: number): string => {


		let today = new Date();
		if (incrementSeconds !== 0) {
			today.setSeconds(today.getSeconds() + incrementSeconds);
		}
		return this.dateToString(today, 'd.m.y H:M:S', true);
	}

	//-----------------------------------------------------------------------------------------------
	getEmptyColumnFilter(): any {

		return { active: false, filterMode: EColumnFilterModes.VALUE , value1: '', value2: '', list: '', emptyDate: false };
	}


	//-----------------------------------------------------------------------------------------------
	getTablePosition(aModuleLevel: number, aActualLevel: number): ETablePositions {

		if ((aModuleLevel === 1) && (aActualLevel === 1)) {
				return ETablePositions.ALONE;
		} else if (aModuleLevel + 1 === aActualLevel) {
			return ETablePositions.MASTER;
		} else if (aModuleLevel === aActualLevel) {
			return ETablePositions.CHILD;
		} else {
			return ETablePositions.INVISIBLE;
		}
	}

	// ------------------------------------------------------------------------------------------
	getColumnForLocalStorage = (aColumn: TColumn): any => {
		// Z kompletní konfigurace jednoho sloupce vrátí sloupec jen s atributy, které se ukládají do localstorage

		let pResultFcn = {};
		// vrácené atributy sloupce
		const pConfigAttrs = ['field', 'widthInt', 'widthpx', 'visible', 'sorted', 'filter'];
		pConfigAttrs.forEach((property) => { 
			pResultFcn[property] = aColumn[property];
		})
		return pResultFcn;
	}


	// ------------------------------------------------------------------------------------------
	getSelectedColumnsParams = (aColumns: Array<string>, aColumnMap: TColumnsMap): TColumnSelectedPropertyArray => {
	// Z původní maps aColumnMap vrátí jen ty položky, které jsou obsaženy v poli aColumns

		let pResultFcn: any[] = [];
		aColumnMap.forEach((colValue, keyCol) => {
			let column: Record<string, any> = {};
			let wasSet = false;
			aColumns.forEach((name) => {
				const colName = name as keyof TColumn;
				if (colValue[colName] !== undefined) {
					column[colName] = colValue[colName];
					wasSet = true;
				}
			})
			if (wasSet) {
				pResultFcn[keyCol] = column;
			}
		})

		return pResultFcn;
	}


	// ------------------------------------------------------------------------------------------
	private getOneColumnAttributes = (fieldName: string, aColumnFromLocalStorage: Array<any>): any => {
	// Projde pole sloupců, kde jsou uloženy atributy jednoho sloupce. Až najde daný sloupec, vrátí jen
	// jeho atributy.

		let resultFcn = null;
		aColumnFromLocalStorage.forEach((columnProperty, propertyKey) => { 
			if (columnProperty.field === fieldName) {
				resultFcn = columnProperty;
			}
		})
		return resultFcn;

	}

	// ------------------------------------------------------------------------------------------
	replaceColumnsFromConfig = (aColumnFromLocalStorage: TColumnsArray, aColumnFromConfigMap: TColumnsMap): TColumnsArray => {


		const pResultFcn: TColumnsArray = [];
		const pReplacedAttrs = ['widthInt', 'widthpx', 'visible', 'sorted', 'filter'];
		const pColumnsInLocalStorage: Array<string> = [];

		let key;
		aColumnFromLocalStorage.forEach((column) => { 
			const oneColumn: TColumn = aColumnFromConfigMap.get(column.field);
			if (typeof oneColumn !== typeof undefined) {
				if (oneColumn.visible || oneColumn.canChangeVisibility) {
					pColumnsInLocalStorage.push(column.field);
					for (key in pReplacedAttrs) {
						oneColumn[pReplacedAttrs[key]] = column[pReplacedAttrs[key]];

					}
					pResultFcn.push(oneColumn);
				}
			}
		})

		aColumnFromConfigMap.forEach((column, columnKey) => { 
			if (!pColumnsInLocalStorage.includes(columnKey)) {
				pResultFcn.push(column);
			}
		})
		return pResultFcn;
	}

	// -----------------------------------------------------------------------------------------------
	getErrorMessageTXT(errObj: ValidationErrors | null, insert: boolean): string {
		let key;
		for (key in errObj) {
			let pErrMess = '';
			switch (key) {
				case 'required':
					if (insert) {
						pErrMess = 'Položka musí být zadána.';
					}
					break;
				case 'pattern':
					if (errObj[key].requiredPattern === '^[0-9]*$') {
						pErrMess = 'Položka smí obsahovat pouze číslice';
					}
					if (errObj[key].requiredPattern === '^[0-9]+(\.[0-9]+)?$') {
						pErrMess = 'Položka smí obsahovat pouze číslice a číslice za desetinnou tečku';
					}
					if (errObj[key].requiredPattern === '^#[0-9A-Fa-f]{6}$') {
						pErrMess = 'Položka musí být ve formátu #RRGGBB';
					}
					break;
				case 'min':
					pErrMess = 'Minimální hodnota položky je ' + errObj[key].min;
					break;
				case 'max':
					pErrMess = 'Maximální hodnota položky je ' + errObj[key].max;
					break;
				case 'email':
					pErrMess = 'E-mail je chybně zadán';
					break;
				case 'minlength':
					pErrMess = 'Položka musí mít ' + errObj[key].requiredLength + ' ' + this.getStringChars(errObj[key].requiredLength);
					break;
				case 'maxlength':
					pErrMess = 'Maximálně ' + errObj[key].requiredLength + ' ' + this.getStringChars(errObj[key].requiredLength);
					break;
				default:
					if (typeof errObj[key].errorMessage === typeof undefined) {
						pErrMess = 'Neznámá chyba';
					} else {
						pErrMess = errObj[key].errorMessage;
					}
					break;
			}
			if (pErrMess.length > 0) {
				return pErrMess;
			}
		}
		return '';
	}

	getStringChars(aNumber: any): string {
		const pLastNumber = Number(String(aNumber).substring(-1));
		let pResult = 'znak';
		if ((pLastNumber > 1) && (pLastNumber < 5)) {
			pResult = 'znaky';
		} else {
			if (pLastNumber > 4) {
				pResult = 'znaků';
			}
		}
		return pResult;
	}

	// ...............................................................................................
	getTableDetailWidth (tableWidthNoMobileInt: number): object {
	// 2px přičítané v detailWidth jsou za table-separator
	// ...............................................................................................
		const windowWidth = window.innerWidth;
		let paramsResult = {'tableWidth': '100%', 'detailWidth': '100%', 'isMobileResolution': true };
		if (windowWidth >= 550) {
			paramsResult = {'tableWidth': tableWidthNoMobileInt.toString() + 'px',
											'detailWidth': 'calc(100% - ' + (tableWidthNoMobileInt + 2) + 'px)',
											'isMobileResolution': false}
		}
		return paramsResult;
	}

}
